import { FilterOption } from '../../components/_WMS/FilterComponent'

export const sinDato = (value: unknown): string => {
  // Verificar si el valor es undefined o null
  if (value === undefined || value === null) return 'N/A'

  if (typeof value === 'string' && value.trim() === '') return 'N/A'

  if (typeof value === 'number') return value.toString()

  if (typeof value === 'string') return value

  // Si llega un tipo de dato inesperado, retornamos 'N/A' por seguridad
  return 'N/A'
}

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'referenceId',
    label: 'ID Referencia',
    type: 'text'
  },
  {
    order: 2,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated'
  },
  {
    order: 3,
    key: 'initialTransactionDate',
    label: 'Fecha Llamada Desde',
    type: 'date'
  },
  {
    order: 4,
    key: 'finalTransactionDate',
    label: 'Fecha Llamada Hasta',
    type: 'date'
  },
  {
    order: 5,
    key: 'externalStatusId',
    label: 'Estado',
    type: 'precreated'
  },
  {
    order: 6,
    key: 'typeActionId',
    label: 'Tipo Acción',
    type: 'precreated'
  }
]

export const defaultFilters = []
